import { useState } from "react";
import { Scroll, X } from "lucide-react";
import { C } from "../constants/colors";
import { ReviewWidget } from "./ReviewWidget";

export function TestimonialGatePanel({
  userId, onUnlocked, onClose, isMobile,
  headerLabel = "Master Blueprint",
  leadLine = "Your full branded export is ready.",
  description = "Before we generate it — your experience matters here. A quick review unlocks the full Master Blueprint compiled from every module in your voice.",
  trigger = "blueprint_gate",
  successMessage = "Thank you. Your Master Blueprint is generating now.",
}) {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div style={isMobile ? {
      position: "fixed", inset: 0, zIndex: 60, background: "#fff", display: "flex", flexDirection: "column",
    } : {
      width: 360, background: "#fff", borderLeft: "1px solid #e8e8f0",
      display: "flex", flexDirection: "column", height: "100vh", flexShrink: 0,
      animation: "slideIn 0.2s ease",
    }}>
      <div style={{ background: C.indigo, padding: "14px 16px", borderBottom: `3px solid ${C.tealLight}`, flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 3 }}>
              <Scroll size={13} color={C.tealLight} />
              <span style={{ color: "#aaa", fontSize: 11, letterSpacing: "0.5px", textTransform: "uppercase" }}>{headerLabel}</span>
            </div>
            <h3 style={{ color: "#fff", margin: 0, fontSize: 15, fontWeight: 700 }}>One last thing</h3>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}>
            <X size={16} color="#aaa" />
          </button>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: "auto", padding: "20px 18px" }}>
        {!submitted ? (
          <>
            <p style={{ margin: "0 0 6px", fontSize: 14, color: C.indigo, fontWeight: 700, lineHeight: 1.5 }}>
              {leadLine}
            </p>
            <p style={{ margin: "0 0 20px", fontSize: 13, color: "#555", lineHeight: 1.65 }}>
              {description}
            </p>
            <ReviewWidget
              userId={userId}
              trigger={trigger}
              onSubmitted={() => { setSubmitted(true); onUnlocked?.(); }}
            />
          </>
        ) : (
          <div style={{ textAlign: "center", paddingTop: 20 }}>
            <div style={{ fontSize: 28, marginBottom: 12 }}>⭐⭐⭐⭐⭐</div>
            <p style={{ fontSize: 13, color: "#555", lineHeight: 1.65 }}>{successMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
}
